import Vue from 'vue'

export const addJob = params => {
  return Vue.fetch.post('/apiv1/quartz/addJob', params)
}

export const deleteJob = params => {
  return Vue.fetch.post('/apiv1/quartz/deleteJob', params)
}

export const updateJob = params => {
  return Vue.fetch.post('/apiv1/quartz/updateJob', params)
}

/**
 * 获取定时任务列表
 * @returns {*}
 */
export const pageList = params => {
  return Vue.fetch.post('/apiv1/quartz/findAll', params)
}

/**
 * 执行任务
 * @param {*} params
 * @returns
 */
export const runJob = params => {
  return Vue.fetch.post('/apiv1/quartz/runJob', params)
}

/**
 * 恢复任务
 * @param {*} params
 * @returns
 */
export const resumeJob = params => {
  return Vue.fetch.post('/apiv1/quartz/resumeJob', params)
}

/**
 * 暂停任务
 * @param {*} params
 * @returns
 */
export const pauseJob = params => {
  return Vue.fetch.post('/apiv1/quartz/pauseJob', params)
}



// WEBPACK FOOTER //
// ./src/services/quartzJobApi.js